import BackButton from "@/components/back-button"
import Logo from "@/components/logo"
import { Col, Layout, Row, Typography } from "antd"
import React, { FC, PropsWithChildren } from "react"
import { NavLink } from "react-router-dom"
import { useTernaryDarkMode } from "usehooks-ts"
import "./AuthLayout.less"
const { Paragraph, Title } = Typography

const AuthLayout: FC<
  { showAdditionalText?: boolean; title?: string; subtitle?: string; backButton?: boolean; fullWidth?: boolean } & PropsWithChildren
> = ({ showAdditionalText, title, subtitle, backButton, fullWidth, children }) => {
  const { isDarkMode } = useTernaryDarkMode({ localStorageKey: "theme" })

  return (
    <Layout className={`auth-layout ${isDarkMode ? "dark" : "light"} ${fullWidth ? "fullwidth" : ""}`}>
      <Layout.Content>
        <Row className="auth-layout-block" style={{ minHeight: '100vh' }}>
          <Col xs={24} sm={24} md={fullWidth ? 24 : 12} className="auth-layout-form">
            <div className="auth-layout-logo">
              <Logo forceDark={!isDarkMode} />
            </div>
            <Row className="auth-layout-form-block">
              <Row className="auth-layout-form-content">
                {backButton && (
                  <Row style={{ marginBottom: 32 }}>
                    <BackButton />
                  </Row>
                )}
                {title && <Title className="auth-form-title">{title}</Title>}
                {subtitle && <Paragraph className="auth-form-subtitle">{subtitle}</Paragraph>}
                {children}
                {showAdditionalText && (
                  <Row className="additional-text-block">
                    <Paragraph className="additional-text">
                      By continuing, you agree to DataCord's{" "}
                      <NavLink to="/terms-service" className="additional-links">
                        Terms of Service
                      </NavLink>{" "}
                      and{" "}
                      <NavLink to="/privacy-policy" className="additional-links">
                        Privacy Policy
                      </NavLink>
                      , and to receive periodic emails containing updates.
                    </Paragraph>
                  </Row>
                )}
              </Row>
            </Row>
          </Col>
          {!fullWidth && (
            <Col xs={0} sm={0} md={12} className="auth-layout-bg">
              <Paragraph className="bg-text">
                {/* Seamlessly connect and integrate your data systems with our powerful iPaaS solution, trusted by enterprises worldwide. */}
              </Paragraph>
            </Col>
          )}
        </Row>
      </Layout.Content>
    </Layout>
  )
}

export default AuthLayout
